import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { AddLeadFieldComponent } from "../../components/lead-fields-configurations/add-lead-field/add-lead-field.component";
import { Menu } from 'primeng/menu';
import { DeleteLeadFieldComponent } from "../../components/lead-fields-configurations/delete-lead-field/delete-lead-field.component";

@Component({
  selector: 'app-configure-leads',
  imports: [SharedModule, ToolBarComponent, AddLeadFieldComponent, DeleteLeadFieldComponent],
  templateUrl: './configure-leads.component.html',
  styleUrl: './configure-leads.component.scss'
})
export class ConfigureLeadsComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddLeadField: boolean = false;
  editLeadFieldData: boolean = false;
  isEditField: boolean = false;
  isDeleteUser: boolean = false;

  items: any[] = [];

  // Tab management
  tabs = [
    { label: 'Lead', value: 'lead', isActive: true },
    { label: 'Registration', value: 'registration', isActive: false },
    { label: 'Application', value: 'application', isActive: false },
    { label: 'Enrollment', value: 'enrollment', isActive: false },
    { label: 'Admission', value: 'admission', isActive: false },
    { label: 'Student', value: 'student', isActive: false }
  ];

  activeTab: string = 'lead';
  
  // Fixed columns for each module type
  fixedColumnsMap: any = {
    lead: [
      { field: 'prefix', label: 'Prefix' },
      { field: 'first_name', label: 'First Name' },
      { field: 'last_name', label: 'Last Name' },
      { field: 'email', label: 'Contact Email' },
      { field: 'contact_phone', label: 'Contact Number' },
      { field: 'alternate_phone', label: 'Alternate Number' },
      { field: 'query_type', label: 'Query Type' },
      { field: 'date_of_birth', label: 'Date of Birth' },
      { field: 'age', label: 'Age' },
      { field: 'gender', label: 'Gender' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'interested_course', label: 'Interested Course' },
      { field: 'preferred_location', label: 'Preferred Location' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'country', label: 'Country' },
      { field: 'postal_code', label: 'Postal Code' },
      { field: 'source', label: 'Source' },
      { field: 'lead_status', label: 'Lead Status' }
    ],
    registration: [
      { field: 'prefix', label: 'Prefix' },
      { field: 'first_name', label: 'First Name' },
      { field: 'last_name', label: 'Last Name' },
      { field: 'email', label: 'Contact Email' },
      { field: 'contact_phone', label: 'Contact Number' },
      { field: 'alternate_phone', label: 'Alternate Number' },
      { field: 'date_of_birth', label: 'Date of Birth' },
      { field: 'age', label: 'Age' },
      { field: 'gender', label: 'Gender' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'preferred_location', label: 'Preferred Location' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'country', label: 'Country' },
      { field: 'postal_code', label: 'Postal Code' },
      { field: 'status', label: 'Status' },
      { field: 'guardian_name', label: 'Guardian Name' },
      { field: 'guardian_contact', label: 'Guardian Contact' },
      { field: 'previous_education', label: 'Previous Education' },
      { field: 'preferred_course', label: 'Preferred Course' },
      { field: 'document_status', label: 'Document Status' },
      { field: 'source', label: 'Source' }
    ],
    application: [
      { field: 'prefix', label: 'Prefix' },
      { field: 'first_name', label: 'First Name' },
      { field: 'last_name', label: 'Last Name' },
      { field: 'email', label: 'Contact Email' },
      { field: 'contact_phone', label: 'Contact Number' },
      { field: 'alternate_phone', label: 'Alternate Number' },
      { field: 'date_of_birth', label: 'Date of Birth' },
      { field: 'age', label: 'Age' },
      { field: 'gender', label: 'Gender' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'preferred_location', label: 'Preferred Location' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'country', label: 'Country' },
      { field: 'postal_code', label: 'Postal Code' },
      { field: 'guardian_name', label: 'Guardian Name' },
      { field: 'guardian_contact', label: 'Guardian Contact' },
      { field: 'previous_education', label: 'Previous Education' },
      { field: 'preferred_course', label: 'Preferred Course' },
      { field: 'source', label: 'Source' },
      { field: 'application_status', label: 'Application Status' },
      { field: 'document_status', label: 'Document Status' }
    ],
    enrollment: [
      { field: 'prefix', label: 'Prefix' },
      { field: 'first_name', label: 'First Name' },
      { field: 'last_name', label: 'Last Name' },
      { field: 'email', label: 'Contact Email' },
      { field: 'contact_phone', label: 'Contact Number' },
      { field: 'alternate_phone', label: 'Alternate Number' },
      { field: 'date_of_birth', label: 'Date of Birth' },
      { field: 'age', label: 'Age' },
      { field: 'gender', label: 'Gender' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'country', label: 'Country' },
      { field: 'postal_code', label: 'Postal Code' },
      { field: 'address', label: 'Address' },
      { field: 'guardian_name', label: 'Guardian Name' },
      { field: 'guardian_contact', label: 'Guardian Contact' }
    ],
    admission: [
      { field: 'prefix', label: 'Prefix' },
      { field: 'first_name', label: 'First Name' },
      { field: 'last_name', label: 'Last Name' },
      { field: 'email', label: 'Contact Email' },
      { field: 'phone', label: 'Phone Number' },
      { field: 'alternate_phone', label: 'Alternate Number' },
      { field: 'date_of_birth', label: 'Date of Birth' },
      { field: 'age', label: 'Age' },
      { field: 'gender', label: 'Gender' },
      { field: 'blood_group', label: 'Blood Group' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'country', label: 'Country' },
      { field: 'postal_code', label: 'Postal Code' },
      { field: 'guardian_name', label: 'Guardian Name' },
      { field: 'guardian_contact', label: 'Guardian Contact' },
      { field: 'previous_education', label: 'Previous Education' },
      { field: 'address', label: 'Address' }
    ],
    student: [
      { field: 'admission_number', label: 'Admission Number' },
      { field: 'student_roll_no', label: 'Student Roll No' },
      { field: 'admission_id', label: 'Admission ID' },
      { field: 'academic_year', label: 'Academic Year' },
      { field: 'admission_type', label: 'Admission Type' },
      { field: 'admission_mode', label: 'Admission Mode' },
      { field: 'first_name', label: 'First Name' },
      { field: 'middle_name', label: 'Middle Name' },
      { field: 'last_name', label: 'Last Name' },
      { field: 'gender', label: 'Gender' },
      { field: 'dob', label: 'Date of Birth' },
      { field: 'age', label: 'Age' },
      { field: 'nationality', label: 'Nationality' },
      { field: 'religion', label: 'Religion' },
      { field: 'caste', label: 'Caste' },
      { field: 'caste_category', label: 'Caste Category' },
      { field: 'aadhar_no', label: 'Aadhar Number' },
      { field: 'passport_no', label: 'Passport Number' },
      { field: 'email', label: 'Email' },
      { field: 'alternate_email', label: 'Alternate Email' },
      { field: 'phone', label: 'Phone' },
      { field: 'alternate_phone', label: 'Alternate Phone' },
      { field: 'address_line1', label: 'Address Line 1' },
      { field: 'address_line2', label: 'Address Line 2' },
      { field: 'city', label: 'City' },
      { field: 'state', label: 'State' },
      { field: 'postal_code', label: 'Postal Code' },
      { field: 'country', label: 'Country' },
      { field: 'permanent_address', label: 'Permanent Address' },
      { field: 'current_address', label: 'Current Address' },
      { field: 'guardian_name', label: 'Guardian Name' },
      { field: 'guardian_relation', label: 'Guardian Relation' },
      { field: 'guardian_phone', label: 'Guardian Phone' },
      { field: 'guardian_email', label: 'Guardian Email' },
      { field: 'guardian_address', label: 'Guardian Address' },
      { field: 'father_name', label: 'Father Name' },
      { field: 'father_phone', label: 'Father Phone' },
      { field: 'father_email', label: 'Father Email' },
      { field: 'father_occupation', label: 'Father Occupation' },
      { field: 'mother_name', label: 'Mother Name' },
      { field: 'mother_phone', label: 'Mother Phone' },
      { field: 'mother_email', label: 'Mother Email' },
      { field: 'mother_occupation', label: 'Mother Occupation' },
      { field: 'annual_income', label: 'Annual Income' },
      { field: 'previous_school', label: 'Previous School' },
      { field: 'previous_class', label: 'Previous Class' },
      { field: 'previous_percentage', label: 'Previous Percentage' },
      { field: 'transfer_certificate', label: 'Transfer Certificate' },
      { field: 'achievements', label: 'Achievements' },
      { field: 'course_id', label: 'Course' },
      { field: 'department_id', label: 'Department' }
    ]
  };

  columns:any[] = [
    {field:'sequence', header:'Sequence', type:'number'},
    {field:'field_name', header:'Field Name'},
    {field:'type', header:'Field Type'},
    {field:'label', header:'Label'},
    {field:'min_length', header:'Min Length', type:'number'},
    {field:'max_length', header:'Max Length', type:'number'},
    {field:'placeholder', header:'Placeholder', type:'placeholder'},
    {field:'required', header:'Required'},
    {field:'isEmail', header:'Is Email'},
    {field:'is_fixed', header:'Type', type:'fixed'},
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];


  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getLeadsFields();
  }

  setActiveTab(tab: string) {
    const selectedTab = this.tabs.find(t => t.value === tab);
    if (selectedTab && !selectedTab.isActive) {
      this.tabs.forEach(t => t.isActive = false);
      selectedTab.isActive = true;
      this.activeTab = tab;
      this.getLeadsFields();
    }
  }

  isFixedField(fieldName: string): boolean {
    const fixedColumns = this.fixedColumnsMap[this.activeTab] || [];
    return fixedColumns.some((col: any) => col.field === fieldName);
  }

    getMenuItems(rowData: any) {
      const isFixed = rowData.is_fixed === true;
      
      return [
        {
          label: 'Options',
          items: [
            {
              label: 'Edit Field',
              icon: 'pi pi-fw pi-pencil',
              command: () => {
                console.log('Edit', rowData);
                this.isEditField = true;
                this.editLeadFieldData = { ...rowData, is_fixed: isFixed };
              }
            },
            {
              label: 'Delete Field',
              icon: 'pi pi-fw pi-trash',
              styleClass: 'delete-menu-item',
              disabled: isFixed,
              command: () => {
                if (!isFixed) {
                  this.isDeleteUser = true;
                  this.editLeadFieldData = rowData;
                }
              }
            }
          ]
        }
      ];
    }
    

  getLeadsFields() {

    let param = {
      organization_id: Number(this.localStorage.getOrganizationId()),
      module_type: this.activeTab
    };
    this.loading = true;
    this.api.getLeadsFields(param).subscribe(
      (data: any) => {
        this.initialLoad = false;
        this.loading = false;
        
        // Get fixed columns for current tab
        const fixedColumns = this.fixedColumnsMap[this.activeTab] || [];
        
        // Create fixed field entries
        const fixedFieldEntries = fixedColumns.map((col: any, index: number) => ({
          field_id: `fixed_${col.field}`,
          field_name: col.field,
          label: col.label,
          type: 'text',
          sequence: index + 1,
          is_fixed: true,
          required: 'false',
          is_email: 'false',
          is_many: 'false',
          is_public: 'false',
          visible_in_table: 'true',
          placeholder: '',
          min_length: 0,
          max_length: 0
        }));
        
        // Get custom fields from API and mark if they match fixed fields
        const customFields = (data.fields || []).map((field: any) => ({
          ...field,
          is_fixed: this.isFixedField(field.field_name)
        }));
        
        // Combine: fixed fields first, then custom fields (excluding duplicates)
        const customNonFixedFields = customFields.filter((field: any) => !field.is_fixed);
        this.dataSource = [...customNonFixedFields, ...fixedFieldEntries];
        
        console.log('DataSource with fixed and custom fields:', this.dataSource);
        this.totalRecords = this.dataSource.length;

        this.filterArray = [
          { key: 'field_name', value: 'Field Name' },
          { key: 'label', value: 'Label' },
          { key: 'type', value: 'Type' },
          { key: 'min-length', value: 'Min Length', type:'number' },
          { key: 'max-length', value: 'Max Length', type:'number' },
          { key: 'placeholder', value: 'Placeholder', type:'placeholder' },
          { key: 'required', value: 'Required' },
        ];
      },
      (error: any) => {
        this.initialLoad = false;
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: (error.error.message ||
          'Something went wrong, Please try again later.'
        ) });
      }
    );
  }

  handleAddLeadField() {
    this.isAddLeadField = true;
  }

  handleCloseDialog() {
    this.isAddLeadField = false;
  }
  

}
